import { useParams } from 'react-router-dom';
import { useLanguage } from '../../../hooks/useLanguage';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isValidLanguage } from '../../utils/validation';

const LanguageGuard = ({ children }) => {
  const { lang } = useParams();
  const { switchLanguage, supportedLanguages } = useLanguage();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && isValidLanguage(lang) && supportedLanguages.includes(lang) && i18n.language !== lang) {
      switchLanguage(lang);
    } else if (lang && !isValidLanguage(lang)) {
    }
  }, [lang, switchLanguage, supportedLanguages, i18n]);
  return children;
};

export default LanguageGuard;